import {gql} from '@apollo/client'

export const CREATE_DOWNLOAD_PRESIGNER = gql`
  mutation CreateDownloadPresigner($id: ID!) {
    createDownloadPresigner(id: $id) {
      id
      uploadId
      filename
      presignedUrl
      expiresAt
    }
  }
`

export const EXTEND_DOWNLOAD = gql`
  mutation ExtendDownload($uploadId: ID!, $id: ID!) {
    extendDownload(uploadId: $uploadId, id: $id) {
      id
      uploadId
      filename
      presignedUrl
      expiresAt
    }
  }
`
